var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModulesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.49717L4.49956 4.49761L3.5 3.49805",
    stroke: "#71717B",
    strokeWidth: 0.999564,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49609 6.49805H7.49522",
    stroke: "#71717B",
    strokeWidth: 0.999564,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49651 1.5H2.49956C1.94752 1.5 1.5 1.94752 1.5 2.49956V9.49651C1.5 10.0486 1.94752 10.4961 2.49956 10.4961H9.49651C10.0486 10.4961 10.4961 10.0486 10.4961 9.49651V2.49956C10.4961 1.94752 10.0486 1.5 9.49651 1.5Z",
    stroke: "#71717B",
    strokeWidth: 0.999564,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModulesIcon);
export default __webpack_public_path__ + "static/media/modules-icon.41a7873adb412b5159bfb0cb1a716d80.svg";
export { ForwardRef as ReactComponent };